import React, { useState } from 'react';
import UsersTab from '../components/usermgmt/UsersTab';
import RolesTab from '../components/usermgmt/RolesTab';
import { useAuth } from '../context/AuthContext';

const tabs = [
  { id: 'users', label: 'USERS' },
  { id: 'roles', label: 'ROLES' },
];

function UserManagement() {
  const [activeTab, setActiveTab] = useState('users');
  const { user } = useAuth();

  return (
    <div className="page-card">
      <div className="settings-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`settings-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="settings-content">
        {activeTab === 'users' && <UsersTab tenantId={user?.tenantId} />}
        {activeTab === 'roles' && <RolesTab tenantId={user?.tenantId} />}
      </div>
    </div>
  );
}

export default UserManagement;
